<template>
  <CustomPanel ref="panel" :title="''" :contentStyle="contentStyle" :closeOnPressEscape="false" class="marker-attribute" v-show="visible" @onClose="onClose">
    <!-- <div slot="tab-panel" class="tab-panel">
      <div class="tab-header" :class="activeTab===1?'active':''" @click="activeTab=1">基础信息</div>
      <div class="tab-header" :class="activeTab===2?'active':''" @click="activeTab=2">数据</div>
    </div> -->
    <div slot="header" class="top-tab">
      <div class="tab-header" :class="activeTab===1?'active':''" @click="onChangeTab(1)">基础信息</div>
      <div class="tab-header" :class="activeTab===2?'active':''" @click="onChangeTab(2)" v-if="markSourceDataShow">图片/视频</div>
      <div class="tab-header" :class="activeTab===3?'active':''" @click="onChangeTab(3)" v-if="markSourceAttachmentShow">文档</div>
    </div>
    <div class="content" slot="content" ref="infoContent" v-show="activeTab===1">
      <el-form class="formContainer" :model="formInline" :rules="rules" ref="form" label-position="right" v-show="!detailModel">
        <el-form-item label="所属图层：" prop="selectedLayer">
          <el-select v-model="formInline.selectedLayer" placeholder="请选择所属图层" :disabled="!!serverMarkerId" class="attribute-item" @change="onSelectLayer">
            <el-option  v-for="item in filteredLayer" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-button @click="onBindTable" class="bind-btn" :disabled="!isCanBindTable">关联表单数据</el-button>
        <el-form-item label="标注名称：" prop="markerName">
          <el-input class="attribute-item" v-model.trim="formInline.markerName" placeholder="请输入20字以内" :maxlength="20" show-word-limit :disabled="detailModel"></el-input>
        </el-form-item>
        <el-form-item label="设备ID：" prop="deviceId" v-if="layerData && layerData.extendConfig && layerData.extendConfig.isSppucData === false">
          <el-input class="attribute-item" v-model.trim="formInline.deviceId" placeholder="请输入设备ID" show-word-limit :disabled="detailModel"></el-input>
        </el-form-item>
        <div class="space-line" v-show="filteredProperty.length>0" ></div>
        <el-form-item class="custom-item" v-show="!bindId && headerItem.display" v-for="(headerItem,index) in formInline.properties" label="" :key="index" :prop="'properties.'+index+'.value'" :rules="getRule(headerItem.type, headerItem.required, bindId)">
          <el-tooltip :content="headerItem.name" placement="top" effect="light" :open-delay="1000" >
            <span class="custom-label"><span v-if="headerItem.required" style="color: red;position: absolute;left: 0;">*</span>{{headerItem.name}}：</span>
          </el-tooltip>
          <el-input class="attribute-item" v-if="headerItem.type==='TEXT'" placeholder="请输入内容" v-model="headerItem.value"></el-input>
          <el-input class="attribute-item" v-if="headerItem.type==='PHONE'" placeholder="请输入内容" v-model="headerItem.value"></el-input>
          <el-input class="attribute-item" v-if="headerItem.type==='LINK'" placeholder="请输入内容" v-model="headerItem.value"></el-input>
          <el-input class="attribute-item" v-if="headerItem.type==='LIVE'" placeholder="请输入内容" v-model="headerItem.value"></el-input>
          <el-input class="attribute-item" v-if="headerItem.type==='NUMBER'" placeholder="请输入内容" v-model="headerItem.value">
            <div v-if="!!headerItem.unit" class="append-icon" slot="suffix">
              <el-tooltip :content="headerItem.unit" placement="top" effect="light" :open-delay="1000" >
                <span>{{headerItem.unit}}</span>
              </el-tooltip>
            </div>
          </el-input>
          <el-date-picker class="attribute-item" v-if="headerItem.type==='DATE'" v-model="headerItem.value" type="date" placeholder="选择日期"></el-date-picker>
          <el-date-picker class="attribute-item" v-if="headerItem.type==='DATE_TIME'" v-model="headerItem.value" type="datetime" placeholder="选择日期时间"></el-date-picker>
          <el-select class="attribute-item" v-if="headerItem.type==='SELECT'" v-model="headerItem.value" placeholder="请选择属性" :multiple="!!headerItem.multiSelect" collapse-tags>
            <el-option v-for="(selItem, index) in headerItem.options" :key="index" :label="selItem.value" :value="selItem.id.toString()"></el-option>
          </el-select>
        </el-form-item>
        <div v-show="!!bindId">
          <div class="attribute-item2" v-for="(headerItem, index) in formInline.properties" :key="index" v-show="headerItem.display">
            <el-tooltip :content="headerItem.name" placement="top" effect="light" :open-delay="1000">
              <div class="title">{{headerItem.name}}</div>
            </el-tooltip>
            <div class="title2">：</div>
            <div class="value">{{formatValue(headerItem)}}</div>
          </div>
        </div>
        <div>
          <div class="space-line"></div>
          <div class="point-item margin-center">
            <div class="name-tag">相机视点</div>
            <el-form-item label="相机经度：" prop="cameraInfo.cameraLon" :rules="rules.cameraLon">
              <el-input class="attribute-item" v-model.trim="formInline.cameraInfo.cameraLon" placeholder="请输入" :disabled="!canChangeGis()" @change="onChangePos"></el-input>
            </el-form-item>
            <el-form-item label="相机纬度：" prop="cameraInfo.cameraLat" :rules="rules.cameraLat">
              <el-input class="attribute-item" v-model.trim="formInline.cameraInfo.cameraLat" placeholder="请输入" :disabled="!canChangeGis()" @change="onChangePos"></el-input>
            </el-form-item>
            <el-form-item label="相机高度：" prop="cameraInfo.cameraHeight" :rules="rules.cameraHeight">
              <el-input class="attribute-item" v-model.trim="formInline.cameraInfo.cameraHeight" placeholder="请输入" :disabled="!canChangeGis()" @change="onChangePos">
                <div class="append-icon" slot="suffix">米</div>
              </el-input>
            </el-form-item>
            <el-form-item label="相机偏航角：" prop="cameraInfo.cameraHeading" :rules="rules.cameraHeading">
              <el-input class="attribute-item" v-model.trim="formInline.cameraInfo.cameraHeading" placeholder="请输入" :disabled="!canChangeGis()" @change="onChangePos"></el-input>
            </el-form-item>
            <el-form-item label="相机俯仰角：" prop="cameraInfo.cameraPitch" :rules="rules.cameraPitch">
              <el-input class="attribute-item" v-model.trim="formInline.cameraInfo.cameraPitch" placeholder="请输入" :disabled="!canChangeGis()" @change="onChangePos"></el-input>
            </el-form-item>
            <el-form-item label="相机翻滚角：" prop="cameraInfo.cameraRoll" :rules="rules.cameraRoll">
              <el-input class="attribute-item" v-model.trim="formInline.cameraInfo.cameraRoll" placeholder="请输入" :disabled="!canChangeGis()" @change="onChangePos"></el-input>
            </el-form-item>
            <div class="camera-btns">
              <el-button @click="onClearCameraViewer">默认视角</el-button>
              <el-button type="primary" @click="onGetCurCameraViewer">当前视角</el-button>
            </div>
          </div>
        </div>
        <div v-if="markerType==='POINT'">
          <div class="space-line"></div>
          <div class="point-item">
            <div class="name-tag">坐标点</div>
            <el-form-item label="经度_WGS84：" prop="pointLon">
              <el-input class="attribute-item" v-model.trim="formInline.pointLon" placeholder="请输入" :disabled="!canChangeGis()" @change="onChangePos"></el-input>
            </el-form-item>
            <el-form-item label="纬度_WGS84：" prop="pointLat">
              <el-input class="attribute-item" v-model.trim="formInline.pointLat" placeholder="请输入" :disabled="!canChangeGis()" @change="onChangePos"></el-input>
            </el-form-item>
            <el-form-item label="高度_WGS84：" prop="pointHeight">
              <el-input class="attribute-item" v-model.trim="formInline.pointHeight" placeholder="请输入" :disabled="!canChangeGis()" @change="onChangePos">
                <div class="append-icon" slot="suffix">米</div>
              </el-input>
            </el-form-item>
          </div>
        </div>
        <div v-if="drawMode===6">
          <div class="space-line"></div>
          <div class="point-item">
            <div class="name-tag">圆心坐标</div>
            <el-form-item label="经度_WGS84：" prop="circleLon">
              <el-input class="attribute-item" v-model.trim="formInline.circleLon" placeholder="请输入" :disabled="!canChangeGis()" @change="onChangeCircle"></el-input>
            </el-form-item>
            <el-form-item label="纬度_WGS84：" prop="circleLat">
              <el-input class="attribute-item" v-model.trim="formInline.circleLat" placeholder="请输入" :disabled="!canChangeGis()" @change="onChangeCircle"></el-input>
            </el-form-item>
            <el-form-item label="圆半径：" prop="circleRadius">
              <el-input class="attribute-item" v-model.trim="formInline.circleRadius" placeholder="请输入" :disabled="!canChangeGis()" @change="onChangeCircle">
                <div class="append-icon" slot="suffix">米</div>
              </el-input>
            </el-form-item>
          </div>
        </div>
        <div v-if="drawMode!==6 && (markerType==='LINE'||markerType==='PLANE')">
          <div class="space-line"></div>
          <div class="point-item" v-for="(item, index) in formInline.gisPoints" :key="index">
            <div class="name-tag">坐标点_{{index+1}}</div>
            <el-form-item label="经度_WGS84：" :prop="'gisPoints.'+index+'[0]'" :rules="getRule('LON', true, false)">
              <el-input class="attribute-item" v-model.trim="item[0]" placeholder="请输入" @change="onChangePoint"></el-input>
            </el-form-item>
            <el-form-item label="纬度_WGS84：" :prop="'gisPoints.'+index+'[1]'" :rules="getRule('LAT', true, false)">
              <el-input class="attribute-item" v-model.trim="item[1]" placeholder="请输入" @change="onChangePoint"></el-input>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <div v-show="detailModel" ref="detailContent" class="formContainer">
        <div class="attribute-item2">
          <div class="title">所属图层：</div>
          <div class="value" >{{getLayerName(formInline.selectedLayer)}}</div>
        </div>
        <div class="attribute-item2">
          <div class="title">标注名称：</div>
          <div class="value" >{{formInline.markerName}}</div>
        </div>
        <div class="space-line" v-show="filteredProperty.length>0"></div>
        <div class="attribute-item2" v-for="(headerItem, index) in formInline.properties" :key="index" v-show="headerItem.display" style="transform: translateX(-0.05rem)">
          <el-tooltip :content="headerItem.name" placement="top" effect="light" :open-delay="1000">
            <div class="title">{{headerItem.name}}</div>
          </el-tooltip>
          <div class="title2">：</div>
          <div class="value" :class="((headerItem.type === 'LIVE'||headerItem.type === 'LINK') && detailModel && headerItem.value) ? 'link':''" @click="onClickItem(headerItem)">{{formatValue(headerItem)}}</div>
        </div>
        <div v-if="false">
          <div class="space-line"></div>
          <div class="point-item margin-center">
            <div class="name-tag">相机视点</div>
            <p></p>
            <div class="attribute-item2">
              <div class="title">相机经度：</div>
              <div class="value" >{{formInline.cameraInfo.cameraLon}}</div>
            </div>
            <div class="attribute-item2">
              <div class="title">相机纬度：</div>
              <div class="value" >{{formInline.cameraInfo.cameraLat}}</div>
            </div>
            <div class="attribute-item2">
              <div class="title">相机高度：</div>
              <div class="value" >{{formInline.cameraInfo.cameraHeight?`${formInline.cameraInfo.cameraHeight}米`:''}}</div>
            </div>
            <div class="attribute-item2">
              <div class="title">相机偏航角：</div>
              <div class="value" >{{formInline.cameraInfo.cameraHeading}}</div>
            </div>
            <div class="attribute-item2">
              <div class="title">相机俯仰角：</div>
              <div class="value" >{{formInline.cameraInfo.cameraPitch}}</div>
            </div>
            <div class="attribute-item2">
              <div class="title">相机翻滚角：</div>
              <div class="value" >{{formInline.cameraInfo.cameraRoll}}</div>
            </div>
          </div>
        </div>
        <div v-if="markerType==='POINT'">
          <div class="space-line"></div>
          <div class="point-item">
            <div class="name-tag">坐标点</div>
            <p></p>
            <div class="attribute-item2">
              <div class="title">经度_WGS84：</div>
              <div class="value" >{{formInline.pointLon}}</div>
            </div>
            <div class="attribute-item2">
              <div class="title">纬度_WGS84：</div>
              <div class="value" >{{formInline.pointLat}}</div>
            </div>
            <div class="attribute-item2">
              <div class="title">高度_WGS84：</div>
              <div class="value" >{{formInline.pointHeight}}米</div>
            </div>
          </div>
        </div>
        <div v-if="drawMode===6">
          <div class="space-line"></div>
          <div class="point-item">
            <div class="name-tag">圆心坐标</div>
            <p></p>
            <div class="attribute-item2">
              <div class="title">经度_WGS84：</div>
              <div class="value" >{{formInline.circleLon}}</div>
            </div>
            <div class="attribute-item2">
              <div class="title">纬度_WGS84：</div>
              <div class="value" >{{formInline.circleLat}}</div>
            </div>
            <div class="attribute-item2">
              <div class="title">圆半径：</div>
              <div class="value" >{{formInline.circleRadius}}米</div>
            </div>
          </div>
        </div>
        <div v-if="drawMode!==6 && (markerType==='LINE'||markerType==='PLANE')">
          <div class="space-line"></div>
          <div class="point-item" v-for="(item, index) in formInline.gisPoints" :key="index">
            <div class="name-tag">坐标点_{{index+1}}</div>
            <p></p>
            <div class="attribute-item2">
              <div class="title">经度_WGS84：</div>
              <div class="value" >{{item[0]}}</div>
            </div>
            <div class="attribute-item2">
              <div class="title">纬度_WGS84：</div>
              <div class="value" >{{item[1]}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content" slot="content" v-show="activeTab===2">
      <div class="image-content">
        <div class="tip" v-show="!detailModel && !demandData">
          <svg width="1em" height="1em" fill="currentColor">
            <use xlink:href="#icon-Tips"></use>
          </svg>
          支持扩展名：jpg、png、jpeg、mp4<br>大小不超过100M
        </div>
        <el-upload accept=".jpg,.png,.jpeg,.mp4" multiple action="" :before-upload = "beforeUpload" :http-request='onUploadData' :on-success="handleSuccess"  :show-file-list="false" v-show="!detailModel && !demandData">
          <div class="add-image">
            <svg width="1em" height="1em" fill="currentColor">
              <use xlink:href="#icon-plus"></use>
            </svg>
          </div>
        </el-upload>
        <div class="upload-progress" v-for="(item) in upFileList" :key="item.name">
          <el-progress  type="circle" :color="'#00A4F0'" :stroke-width="10" :percentage="item.uploadPrecentange"></el-progress>
        </div>
        <div class="picture" v-for="(item, i) in achievements" :key="i">
          <div class="tag" v-show="item.type==='video'">视频</div>
          <!-- <img class="img-preview" :src="item.url + (item.type==='video'?'?x-oss-process=video/snapshot,t_1000,f_jpg,w_32,h_32':'')"> -->
          <el-image class="img-preview" :src="item.url + (item.type==='video'?'?x-oss-process=video/snapshot,t_1000,f_jpg,w_32,h_32':'')">
            <div slot="placeholder" class="image-slot">
              加载中...
            </div>
            <div slot="error" class="image-error">
              <span>加载失败</span>
            </div>
          </el-image>
          <div class="cover">
            <svg width="1em" height="1em" fill="currentColor" @click="onPreviewPic(item,i)">
              <use xlink:href="#icon-search1"></use>
            </svg>
            <svg width="1em" height="1em" fill="currentColor" v-show=" !demandData && !detailModel" @click="onDeletePic(item,i)">
              <use xlink:href="#icon-ashbin"></use>
            </svg>
          </div>
        </div>
        <div class="empty" v-show="(detailModel||demandData) && achievements.length<=0">
          <Empty></Empty>
        </div>
      </div>
    </div>
    <div class="content" slot="content" v-show="activeTab===3">
      <el-upload accept=".pdf" multiple action="" :before-upload = "beforeDocsUpload" :http-request='onUploadDocs' :show-file-list="false" v-show="!detailModel">
        <div class="upload-accessory" v-show="docs.length+docsUpList.length<=0">
          <img src="@/assets/images/enclosure.png">
          <div>上传附件</div>
          <div class="accessory-tips">支持扩展名：pdf<br>大小不超过10M</div>
        </div>
        <div class="upload-accessory2" v-show="docs.length+docsUpList.length>0">
          <img src="@/assets/images/enclosure.png">
          上传附件
        </div>
      </el-upload>
      <div class="accessory-item" v-for="(item, i) in docs" :key="'docs-'+i">
        <div class="name">
          <svg width="1em" height="1em">
            <use xlink:href="#icon-pdf"></use>
          </svg>
          <el-tooltip :content="item.name" placement="top" effect="light" :open-delay="1000" >
            <span class="name-text" @click="onPreviewPdf(item, i)">{{item.name}}</span>
          </el-tooltip>
          <svg width="1em" height="1em" fill="currentColor" v-show="!detailModel" class="remove" @click="onRemovePdf(item, i)">
            <use xlink:href="#icon-close-bold"></use>
          </svg>
          <div class="progress-status">
            <!-- <span class="uploading">30%</span> -->
            <i class="el-icon-circle-check success" v-if="item.status==='success'"></i>
            <!-- <i class="el-icon-circle-close failed"></i> -->
          </div>
        </div>
        <!-- <el-progress class="accessory-progress" :color="'#00A4F0'" :stroke-width="2" :percentage="10" status="success" :show-text="false"></el-progress> -->
      </div>
      <div class="accessory-item" v-for="(item, i) in docsUpList" :key="'docsup-'+i">
        <div class="name">
          <svg width="1em" height="1em">
            <use xlink:href="#icon-pdf"></use>
          </svg>
          <el-tooltip :content="item.name" placement="top" effect="light" :open-delay="1000" >
            <span class="name-text">{{item.name}}</span>
          </el-tooltip>
          <!-- <svg width="1em" height="1em" fill="currentColor" class="remove" @click="onCancelUpPdf(item, i)">
            <use xlink:href="#icon-close-bold"></use>
          </svg> -->
          <div class="progress-status">
            <span class="uploading">{{item.uploadPrecentange}}%</span>
            <!-- <i class="el-icon-circle-check success"></i>
            <i class="el-icon-circle-close failed"></i> -->
          </div>
        </div>
        <el-progress class="accessory-progress" :color="'#00A4F0'" :stroke-width="2" :percentage="item.uploadPrecentange" :show-text="false"></el-progress>
      </div>
      <div class="image-content" v-show="detailModel && docs.length<=0">
        <div class="empty">
          <Empty></Empty>
        </div>
      </div>
    </div>
    <div class="footer" slot="footer" v-if="isEditMarker">
      <div class="right" v-if="detailModel">
        <el-button type="default" @click="onShowHTMLEditor" v-if="layerInfo && layerInfo.action && layerInfo.action.uiType==='html'">图文信息</el-button>
        <el-button type="danger" @click="removeMarker">删除</el-button>
        <el-button type="primary" @click="onEditModel">编辑</el-button>
      </div>
      <div class="right" v-else-if="!!serverMarkerId ">
        <el-button @click="cancelModify()">取消</el-button>
        <el-button type="primary" @click="onModifyMark" :loading="upFileList.length>0 || loading">提交</el-button>
      </div>
      <div class="right" v-else>
        <el-button  @click="cancelMarker">取消</el-button>
        <el-button type="primary" @click="onCreateSppucMarker" :loading="upFileList.length>0 || loading"
          v-if="layerData && layerData.module === 'sppuc' && layerData.extendConfig && layerData.extendConfig.isSppucData === false">提交</el-button>
        <el-button type="primary" @click="onCreateMark" :loading="upFileList.length>0 || loading" v-else >提交</el-button>
      </div>
    </div>
  </CustomPanel>
</template>

<script>
import CustomPanel from '@/components/CustomPanel'
import { validateNumber, validateGT0, validateURL, validatePhone, validateLive, validateLongitude, validateLatitude } from '@/utils/rules'
import { getLayerList, addMarker, updateMarker, addMarkerBatch, getMarkerDetails, delMarker, addDeviceMarkerBatch } from '@/api/marker'
import { uploadOss } from '@/api/system'
import * as markerStyles from '@/utils/markerStyles'
import { mapGetters } from 'vuex'
// import coordtransform from 'coordtransform'
// import { isHaveGis } from '@/utils/util'
// import TableMarkerBind from './TableMarkerBind'
// import GeoJSON from 'geojson'
import ShareUtil from '@/utils/share'
import { PermissionLevel } from '@/configs/constants'
import { validateCameraInfo } from '@/utils/util'

import GeoJSON from 'geojson'
export default {
  name: 'MarkerAttribute',
  components: {
    CustomPanel
  },
  inject: ['shared'],
  computed: {
    ...mapGetters(['markerPositionEdit', 'isTemplate', 'spaceSearchJeojson', 'isShowSpaceTool', 'permissionLevel', 'markerDatas']),
    // 图层列表
    filteredLayer () {
      const layers = []
      for (let i = 0; i < this.layerList.length; i++) {
        const item = this.layerList[i]
        if (item.type !== this.markerType || item.dataSourceType === 'API' || (item.extendConfig && item.extendConfig.isSppucData === true)) {
          continue
        }
        layers.push(item)
      }
      return layers
    },
    layerData () {
      if (this.formInline.selectedLayer) {
        const layer = this.layerList.find(item => {
          return item.id === this.formInline.selectedLayer
        })
        return layer
      }
      return undefined
    },
    markSourceDataShow () {
      return !this.shared || new ShareUtil().show('markSourceDataShow')
    },
    markSourceAttachmentShow () {
      return !this.shared || new ShareUtil().show('markSourceAttachmentShow')
    },
    isEditMarker () {
      if (this.permissionLevel <= PermissionLevel.LOOKER) {
        // 案例模板，不允许编辑
        return false
      } else if (this.shared) {
        // 分享状态，不允许编辑
        return false
      } else if (this.spaceSearchJeojson || this.isShowSpaceTool) {
        // 空间查询状态，不允许编辑
        return false
      } else {
        return this.canEditMarker
      }
    },
    // 过滤不显示的属性
    filteredProperty () {
      return this.formInline.properties.filter(item => {
        return item.display
      })
    },
    isInMarkerEditing () {
      return this.visible && !this.detailModel
    },
    layerInfo () {
      return this.layerList.find(item => { return item.id === this.formInline.selectedLayer })
    }
  },
  watch: {
    visible (val) {
      this.$store.dispatch('setDrawState', val)
    },
    isInMarkerEditing (val) {
      this.$store.commit('SET_IN_MARKER_EDITING', this.isInMarkerEditing)
    },
    // 标注位置编辑
    markerPositionEdit (val) {
      if (String(val.id) === this.entityId || String(val.id) === String(this.serverMarkerId)) {
        this.updateMarkerPosition(val.position)
      }
    }
  },
  beforeDestroy () {
    if (this.entityId) {
      const marker = this.$cesiumPlus.markerManager.getMarkerById(this.entityId)
      if (marker && marker.layerId !== 'poisearch') {
        this.$cesiumPlus.markerManager.removeMarkerById(this.entityId)
      }
    }
    this.clear()
  },
  data () {
    return {
      contentStyle: {
        height: 'auto'
      },
      titleName: '新增',
      visible: false,

      activeTab: 1,

      markerAddress: '未知地点',

      formInline: {
        selectedLayer: undefined,
        markerName: undefined,
        // 相机视点
        cameraInfo: {
          cameraLon: undefined,
          cameraLat: undefined,
          cameraHeight: undefined,
          cameraHeading: undefined,
          cameraPitch: undefined,
          cameraRoll: undefined
        },
        // 点标注位置
        pointLon: 0,
        pointLat: 0,
        pointHeight: 0,
        // 圆心与半径
        circleLon: 0,
        circleLat: 0,
        circleRadius: 0,
        // 线面节点
        gisPoints: [],
        // 自定义属性头
        properties: [],
        PermissionLevel
      },
      dataType: [
        { value: 'TEXT', name: '文本类型' },
        { value: 'NUMBER', name: '数值' },
        { value: 'DATE', name: '日期' },
        { value: 'DATE_TIME', name: '日期+时间' },
        { value: 'LINK', name: '网页链接' },
        { value: 'PHONE', name: '电话号码' },
        { value: 'LIVE', name: '直播源' },
        { value: 'SELECT', name: '下拉选项' }
      ],
      canEditMarker: false,
      // 图层列表
      layerList: [],
      entityId: undefined,
      // 标注服务端id
      serverMarkerId: undefined,
      // 标注类型
      markerType: undefined,
      // 绑定标注id
      bindId: undefined,
      // 是否可绑定表单
      isCanBindTable: false,
      // 查看详情模型
      detailModel: false,
      drawMode: undefined,
      // 校验规则
      rules: {
        markerName: [
          { required: true, message: '请输入标记名称', trigger: 'blur' },
          { min: 1, max: 20, message: '请输入20字以内', trigger: 'blur' }
        ],
        deviceId: [
          { required: true, message: '请输入设备ID名称', trigger: 'blur' }
        ],
        selectedLayer: [
          { required: true, message: '请选择图层', trigger: 'change' }
        ],
        pointLon: [
          { required: true, message: '请输入标注经度', trigger: 'blur' },
          { validator: validateLongitude, trigger: 'blur' }
        ],
        pointLat: [
          { required: true, message: '请输入标注纬度', trigger: 'blur' },
          { validator: validateLatitude, trigger: 'blur' }
        ],
        pointHeight: [
          { required: true, message: '请输入标注高度', trigger: 'blur' },
          { validator: validateNumber, trigger: 'blur' }
        ],
        circleLon: [
          { required: true, message: '请输入圆心经度', trigger: 'blur' },
          { validator: validateLongitude, trigger: 'blur' }
        ],
        circleLat: [
          { required: true, message: '请输入圆心纬度', trigger: 'blur' },
          { validator: validateLatitude, trigger: 'blur' }
        ],
        circleRadius: [
          { required: true, message: '请输入圆半径', trigger: 'blur' },
          { validator: validateGT0, trigger: 'blur' }
        ]
      },
      stringRequire: { required: true, message: '请输入内容', trigger: 'blur' },
      numberRule: { validator: validateNumber, message: '请输入数值', trigger: 'blur' },
      numberRequireRule: [
        { required: true, message: '请输入数值', trigger: 'blur' },
        { validator: validateNumber, message: '请输入数值类型', trigger: 'blur' }
      ],
      phoneRule: { validator: validatePhone, message: '电话号码格式错误', trigger: 'blur' },
      phoneRequireRule: [
        { required: true, message: '请输入电话号码', trigger: 'blur' },
        { validator: validatePhone, message: '电话号码格式错误', trigger: 'blur' }
      ],
      urlRule: { validator: validateURL, message: '请输入网页链接', trigger: 'blur' },
      urlRequireRule: [
        { required: true, validator: validateURL, message: '请输入网页链接', trigger: 'blur' },
        { validator: validateURL, message: '网页链接格式错误', trigger: 'blur' }
      ],
      liveRule: [
        { validator: validateLive, message: '只支持m3u8,flv格式直播', trigger: 'blur' }
      ],
      liveRequireRule: [
        { required: true, validator: validateLive, message: '请输入网页链接', trigger: 'blur' },
        { validator: validateLive, message: '只支持m3u8,flv格式直播', trigger: 'blur' }
      ],

      gisHeader: {
        lonHeader: undefined,
        latHeader: undefined,
        nameHeader: undefined,
        heightHeader: undefined
      },
      isImageUploading: false,
      isVideoUploading: false,
      loading: false,
      // 所有图片视频
      achievements: [],
      // 是否需求成果数据
      demandData: false,
      // 上传文件列表
      upFileList: [],
      cancelTokens: [],

      // 附件列表
      docs: [],
      docsUpList: [],
      docsCancelTokens: []
    }
  },
  methods: {
    show ({ serverMarkerId, type, markerName, deviceId, entityId, selectedLayerId }) {
      // console.log('------------', coordtransform.gcj02towgs84(104.056245, 30.537353))
      this.visible = true
      this.canEditMarker = true
      // 展开界面并置顶
      this.$refs.panel.unFold(true)
      this.$refs.panel.top()
      this.markerType = type
      this.entityId = entityId
      this.formInline.selectedLayer = selectedLayerId
      if (markerName) {
        this.formInline.markerName = markerName
      }
      if (deviceId) {
        this.formInline.deviceId = deviceId
      }
      // 节点编辑
      const marker = this.$cesiumPlus.markerManager.getMarkerById(this.entityId)
      marker.show(false)
      this.markerEditor = this.$cesiumPlus.markerEditorFactory.createEditorbyMarker(marker)
      this.drawMode = marker.drawMode
      if (this.markerType === 'POINT') { // 点标注设置经纬度
        const gisPos = marker.getGisPosition()
        this.formInline.pointLon = parseFloat(gisPos[0].toFixed(6))
        this.formInline.pointLat = parseFloat(gisPos[1].toFixed(6))
        this.formInline.pointHeight = parseFloat(gisPos[2].toFixed(3))
      } else if (this.drawMode === CesiumPlus.DrawMode.Circle) { // 圆标注
        const circleCenter = marker.getProperties('center_position_')
        const radius = marker.getProperties('radius_')
        this.formInline.circleLon = parseFloat(circleCenter[0].toFixed(6))
        this.formInline.circleLat = parseFloat(circleCenter[1].toFixed(6))
        this.formInline.circleRadius = parseFloat(radius.toFixed(3))
      } else if (this.markerType === 'LINE') { // 线
        this.formInline.gisPoints = []
        const polylineGis = marker.getPolylineGisPositions()
        polylineGis.forEach(item => {
          const pos = [
            parseFloat(item[0].toFixed(6)),
            parseFloat(item[1].toFixed(6))
          ]
          this.formInline.gisPoints.push(pos)
        })
      } else if (this.markerType === 'PLANE') { // 面
        this.formInline.gisPoints = []
        const polygoneGis = marker.getPolygonGisPositions()
        polygoneGis.forEach(item => {
          const pos = [
            parseFloat(item[0].toFixed(6)),
            parseFloat(item[1].toFixed(6))
          ]
          this.formInline.gisPoints.push(pos)
        })
      }
      this.formInline.cameraInfo = JSON.parse(marker.getProperties('camera_info') || '{}')
      this.getAllLayers()
      this.$nextTick(() => {
        this.$store.dispatch('setDrawState', true)
        if (this.$refs.form) {
          this.$refs.form.$el.scrollTop = 0
        }
        if (this.$refs.detailContent) {
          this.$refs.detailContent.scrollTop = 0
        }
        if (this.$refs.infoContent) {
          this.$refs.infoContent.scrollTop = 0
        }
      })
    },
    async onChangeTab (index) {
      if (index !== 1) {
        try {
          await this.$refs.form.validate()
        } catch (error) {
          this.$message.warning('当前页面有未完成信息')
          return
        }
      }
      this.activeTab = index
    },
    getLayerName (value) {
      if (!value || !this.layerList) return ''
      for (let i = 0; i < this.layerList.length; i++) {
        const item = this.layerList[i]
        if (item.id === value) {
          return item.name
        }
      }
      return ''
    },
    setEditMarker (serverMarkerId) {
      this.visible = true
      if (this.$refs.infoContent) {
        this.$refs.infoContent.scrollTop = 0
      }
      if (this.$refs.detailContent) {
        this.$refs.detailContent.scrollTop = 0
      }

      // 展开界面并置顶
      this.$refs.panel.unFold(true)
      this.$refs.panel.top()
      this.serverMarkerId = serverMarkerId
      this.getAllLayers()
      this.activeTab = 1
    },
    edit (serverMarkerId, activeTab) {
      this.detailModel = false
      this.canEditMarker = true
      this.setEditMarker(serverMarkerId)
      if (activeTab) {
        this.activeTab = activeTab
      }
      this.$nextTick(() => {
        this.$store.dispatch('setDrawState', true)
      })
    },
    detail (serverMarkerId) {
      this.setEditMarker(serverMarkerId)
      this.detailModel = true
      this.canEditMarker = this.$route.name === 'Marker'
    },
    // 获取标注详情
    getMarkerDetail () {
      getMarkerDetails({
        id: this.serverMarkerId
      }).then(res => {
        if (res.code === 200) {
          // this.markerType = res.data.layerId
          this.achievements = res.data.achievements
          if (!this.achievements) {
            this.achievements = []
          }
          this.docs = res.data.docs
          if (!this.docs) {
            this.docs = []
          }
          this.drawMode = parseInt(res.data.geoJson.properties.draw_mode_)
          this.formInline.markerName = res.data.name
          this.formInline.deviceId = res.data.deviceId
          this.formInline.selectedLayer = res.data.layerId
          this.bindId = !res.data.customize
          this.demandData = !!res.data.demandData
          this.formInline.tableId = res.data.tableId
          this.formInline.geoJson = res.data.geoJson

          for (let i = 0; i < this.layerList.length; i++) {
            if (this.layerList[i].id === this.formInline.selectedLayer) {
              this.gisHeader = this.getGisHeader(this.layerList[i].properties)
              this.markerType = this.layerList[i].type
            }
          }
          if (!this.drawMode || isNaN(this.drawMode)) {
            if (this.markerType === 'POINT') {
              this.drawMode = CesiumPlus.DrawMode.Marker
            } else if (this.markerType === 'LINE') {
              this.drawMode = CesiumPlus.DrawMode.Polyline
            } else if (this.markerType === 'PLANE') {
              this.drawMode = CesiumPlus.DrawMode.Polygon
            }
          }
          if (this.markerType === 'POINT') {
            const coordinates = res.data.geoJson.geometry.coordinates
            let height = coordinates[3]
            if (res.data.geoJson.properties.height_) {
              height = JSON.parse(res.data.geoJson.properties.height_)[0]
            }
            this.formInline.pointLon = parseFloat(coordinates[0].toFixed(6))
            this.formInline.pointLat = parseFloat(coordinates[1].toFixed(6))
            this.formInline.pointHeight = height ? parseFloat(height).toFixed(3) : 0
          } else if (this.drawMode === CesiumPlus.DrawMode.Circle) { // 圆标注
            const circleCenter = JSON.parse(res.data.geoJson.properties.center_position_)
            const radius = parseFloat(res.data.geoJson.properties.radius_)
            this.formInline.circleLon = parseFloat(circleCenter[0].toFixed(6))
            this.formInline.circleLat = parseFloat(circleCenter[1].toFixed(6))
            this.formInline.circleRadius = parseFloat(radius.toFixed(3))
          } else if (this.markerType === 'LINE') { // 线
            this.formInline.gisPoints = []
            // const polylineGis = marker.getPolylineGisPositions()
            const coordinates = res.data.geoJson.geometry.coordinates
            coordinates.forEach(item => {
              const pos = [
                parseFloat(item[0].toFixed(6)),
                parseFloat(item[1].toFixed(6))
              ]
              this.formInline.gisPoints.push(pos)
            })
          } else if (this.markerType === 'PLANE') { // 面
            this.formInline.gisPoints = []
            // const polygoneGis = marker.getPolygonGisPositions()
            const coordinates = res.data.geoJson.geometry.coordinates[0]
            for (let i = 0; i < coordinates.length; i++) {
              const item = coordinates[i]
              if (i === coordinates.length - 1 && item[0] === coordinates[0][0] && item[1] === coordinates[0][1] && item[2] === coordinates[0][2]) {
                continue
              }
              const pos = [
                parseFloat(item[0].toFixed(6)),
                parseFloat(item[1].toFixed(6))
              ]
              this.formInline.gisPoints.push(pos)
            }
          }
          this.formInline.cameraInfo = JSON.parse(res.data.geoJson.properties.camera_info || '{}')
          this.onSelectLayer(this.formInline.selectedLayer)
          this.$nextTick(() => {
            for (let i = 0; i < this.formInline.properties.length; i++) {
              let key = this.formInline.properties[i].originPropertyId // 绑定的标注
              if (res.data.customize) {
                key = this.formInline.properties[i].id
              }
              // const key = this.formInline.properties[i].id // 自己创建的标注
              let value
              let serverId
              for (let j = 0; j < res.data.values.length; j++) {
                if (res.data.values[j].propertyId === key) {
                  value = res.data.values[j].value
                  serverId = res.data.values[j].id
                }
              }
              if (this.formInline.properties[i].type === 'SELECT' && this.formInline.properties[i].multiSelect === true) {
                if (value) {
                  value = value.split(',')
                } else {
                  value = []
                }
              }
              // this.formInline.properties[i].value = value
              this.$set(this.formInline.properties[i], 'value', value)
              this.$set(this.formInline.properties[i], 'serverId', serverId)
              // console.log(value)
            }

            // 节点编辑
            if (this.canEditMarker && !this.detailModel && this.canChangeGis()) {
              const marker = this.$cesiumPlus.markerManager.getMarkerById(this.serverMarkerId)
              if (!marker.isVisibleInScene()) {
                const searchMarker = this.$cesiumPlus.markerManager.getMarkerById(`markerSearch-${this.serverMarkerId}`)
                if (searchMarker) {
                  searchMarker.show(false)
                }
              }
              if (marker) {
                this.markerEditor = this.$cesiumPlus.markerEditorFactory.createEditorbyMarker(marker)
                marker.show(false)
              } else {
                this.markerEditor = this.$cesiumPlus.markerEditorFactory.createEditorbyGeoJson({
                  id: this.serverMarkerId,
                  geoJson: res.data.geoJson
                })
              }
            }
          })
        }
      })
    },
    // 获取图层列表
    getAllLayers () {
      const mapId = this.$route.query.mapId ? this.$route.query.mapId : 0
      getLayerList({
        mapId: mapId
      }).then(res => {
        if (res.code === 200) {
          this.layerList = res.data
          if (this.serverMarkerId) {
            this.getMarkerDetail()
          } else {
            this.onSelectLayer(this.formInline.selectedLayer)
          }
        }
      })
    },
    // 选择图层
    onSelectLayer (value) {
      this.$store.dispatch('setLayerId', value)
      for (let i = 0; i < this.layerList.length; i++) {
        if (this.layerList[i].id === value) {
          // this.formInline.properties = this.layerList[i].properties
          if (this.layerList[i].properties) {
            this.$set(this.formInline, 'properties', JSON.parse(JSON.stringify(this.layerList[i].properties)))
          } else {
            this.$set(this.formInline, 'properties', [])
          }

          this.formInline.tableId = this.layerList[i].tableId
          // 是否可绑定数据
          // const tableId = this.layerList[i].tableId
          this.isCanBindTable = !!this.formInline.tableId && !this.layerList[i].dataFree && !this.serverMarkerId
          if (this.isCanBindTable) {
            this.$emit('reloadBindMarker', this.formInline.selectedLayer)
          } else {
            this.$emit('closeBindMarker')
          }

          this.gisHeader = this.getGisHeader(this.layerList[i].properties)
        }
      }
    },
    // 校验规则
    getRule (type, required, bindId) {
      if (bindId) {
        return
      }
      if (required) {
        switch (type) {
          case 'TEXT':
            return this.stringRequire
          case 'NUMBER':
            return this.numberRequireRule
          case 'LINK':
            return this.urlRequireRule
          case 'LIVE':
            return this.liveRequireRule
          case 'PHONE':
            return this.phoneRequireRule
          case 'LON':
            return this.rules.pointLon
          case 'LAT':
            return this.rules.pointLat
          default:
            return this.stringRequire
        }
      } else {
        switch (type) {
          case 'NUMBER':
            return this.numberRule
          case 'LINK':
            return this.urlRule
          case 'LIVE':
            return this.liveRule
          case 'PHONE':
            return this.phoneRule
        }
      }
    },
    formatValue (item) {
      let value = '无'
      if (item.value === undefined || item.value === null) {
        return '无'
      }
      if (item.type === 'SELECT') {
        let keyValue = item.value
        if (item.multiSelect === false) {
          keyValue = [item.value]
        }
        if (keyValue && keyValue.length > 0) {
          value = ''
        }
        for (let j = 0; j < keyValue.length; j++) {
          const subKey = keyValue[j]
          for (let i = 0; i < item.options.length; i++) {
            if (item.options[i].id.toString() === subKey.toString()) {
              value += item.options[i].value
              if (j !== keyValue.length - 1) {
                value += ','
              }
            }
          }
        }
        return value
      } else if (item.type === 'NUMBER') {
        value = item.value ?? '无'
        if (item.unit) {
          value = item.value + item.unit
        }
      } else if (item.type === 'DATE') {
        value = '无'
        if (item.value) {
          if (isNaN(new Date(item.value).getTime())) {
            value = item.value
          } else {
            value = new Date(item.value).format('yyyy/MM/dd')
          }
        }
      } else if (item.type === 'DATE_TIME') {
        value = '无'
        if (item.value) {
          if (isNaN(new Date(item.value).getTime())) {
            value = item.value
          } else {
            value = new Date(item.value).format('yyyy/MM/dd hh:mm:ss')
          }
        }
      } else if (item.type === 'LINK') {
        value = this.detailModel ? '点击打开链接' : item.value
      } else if (item.type === 'LIVE') {
        value = this.detailModel ? '点击查看直播源' : item.value
      } else {
        value = item.value ?? '无'
      }
      return value
    },
    onBindTable () {
      // this.$refs.tableMarkerBind.show(this.formInline.selectedLayer)
      this.$emit('showBindMarker', this.formInline.selectedLayer)
    },
    bindMarker (item) {
      if (!item) {
        this.bindId = undefined
        for (let i = 0; i < this.formInline.properties.length; i++) {
          // this.formInline.properties[i].value = undefined
          this.$set(this.formInline.properties[i], 'value', undefined)
        }
      } else {
        this.bindId = item.uniqueId
        for (let i = 0; i < this.formInline.properties.length; i++) {
          const key = this.formInline.properties[i].id
          const value = item[key]
          // this.formInline.properties[i].value = value
          this.$set(this.formInline.properties[i], 'value', value)
          if (this.formInline.properties[i].nameTag && this.formInline.properties[i].nameTag.indexOf('MARK') >= 0) {
            this.formInline.markerName = value
          }
        }
      }
    },
    getGisHeader (header) {
      let lonHeader
      let latHeader
      let nameHeader
      let heightHeader
      for (let i = 0; i < header.length; i++) {
        if (header[i].tag && header[i].tag.indexOf('LONGITUDE') >= 0) {
          lonHeader = header[i].id
        }
        if (header[i].tag && header[i].tag.indexOf('LATITUDE') >= 0) {
          latHeader = header[i].id
        }
        if (header[i].nameTag && header[i].nameTag.indexOf('MARK') >= 0) {
          nameHeader = header[i].id
        }
        if (header[i].tag && header[i].tag.indexOf('HEIGHT') >= 0) {
          heightHeader = header[i].id
        }
      }
      return {
        lonHeader: lonHeader,
        latHeader: latHeader,
        nameHeader: nameHeader,
        heightHeader: heightHeader
      }
    },
    // 数据可修改gis信息
    canChangeGis () {
      // debugger
      // return !(this.gisHeader.lonHeader && this.gisHeader.latHeader) || !this.bindId
      // if (this.gisHeader.lonHeader && this.gisHeader.latHeader) {
      //   return false
      // }
      let lon = false
      let lat = false
      this.formInline.properties.forEach(item => {
        if (item.tag && item.tag.indexOf('LONGITUDE') >= 0 && item.value && !isNaN(parseFloat(item.value))) {
          lon = true
        }
        if (item.tag && item.tag.indexOf('LATITUDE') >= 0 && item.value && !isNaN(parseFloat(item.value))) {
          lat = true
        }
      })
      return !(lon && lat && this.markerType === 'POINT' && this.bindId)
    },
    // 取消标注
    cancelMarker () {
      if (this.entityId) {
        const marker = this.$cesiumPlus.markerManager.getMarkerById(this.entityId)
        if (marker && marker.layerId !== 'poisearch') {
          this.$cesiumPlus.markerManager.removeMarkerById(this.entityId)
        }
      }
      this.close()
    },
    // 取消修改
    cancelModify () {
      // if (this.markerType === 'POINT' && this.serverMarkerId) {
      //   const marker = this.$cesiumPlus.markerManager.getMarkerById(this.serverMarkerId)
      //   const coordinates = JSON.parse(JSON.stringify(this.formInline.geoJson.geometry.coordinates))
      //   const gisPos = coordinates
      //   if (!gisPos[2] && this.formInline.geoJson.properties.height_) {
      //     gisPos[2] = JSON.parse(this.formInline.geoJson.properties.height_)[0]
      //   }
      //   if (marker) {
      //     marker.setPosition(gisPos)
      //   }
      // } else if (this.drawMode === CesiumPlus.DrawMode.Circle) { // 圆标注
      //   const marker = this.$cesiumPlus.markerManager.getMarkerById(this.serverMarkerId)
      //   const centerPos = JSON.parse(this.formInline.geoJson.properties.center_position_)
      //   const circleRadius = parseFloat(this.formInline.geoJson.properties.radius_)
      //   if (marker) {
      //     marker.setCircleGis(centerPos, circleRadius)
      //   }
      // } else if (this.markerType === 'LINE') { // 线

      // } else if (this.markerType === 'PLANE') { // 面

      // }
      this.close()
    },
    // 获取自定义信息
    getCustomInfo () {
      // 自定义属性
      const custom = []
      for (const key in this.formInline.properties) {
        let value = this.formInline.properties[key].value
        if (value) {
          value = value.toString()
        }
        custom.push({
          propertyId: this.formInline.properties[key].id,
          value: value
        })
      }
      return custom
    },
    getNewCustomInfo () {
      // 自定义属性
      const custom = []
      for (const key in this.formInline.properties) {
        let value = this.formInline.properties[key].value
        if (value) {
          value = value.toString()
        }
        custom.push({
          id: this.formInline.properties[key].serverId,
          propertyId: this.formInline.properties[key].id,
          value: value
        })
      }
      return custom
    },
    // 修改标注
    modifyMark () {
      this.loading = true
      this.syncMarkerPosition()
      const geoJson = JSON.parse(JSON.stringify(this.formInline.geoJson))
      // geoJson.properties.name = this.formInline.markerName
      // geoJson.properties.custom = JSON.stringify(this.getCustomInfo())
      // 点标注修改经纬度
      if (this.markerType === 'POINT') {
        geoJson.geometry.coordinates = [parseFloat(this.formInline.pointLon), parseFloat(this.formInline.pointLat), parseFloat(this.formInline.pointHeight)]
        geoJson.properties.height_ = JSON.stringify([parseFloat(this.formInline.pointHeight)])
      } else if (this.drawMode === CesiumPlus.DrawMode.Circle) { // 圆标注
        const marker = this.$cesiumPlus.markerManager.getMarkerById(this.serverMarkerId)
        const markerJson = JSON.parse(marker.toGeoJson())
        geoJson.geometry.coordinates = markerJson.geometry.coordinates
        geoJson.properties.center_position_ = JSON.stringify([this.formInline.circleLon, this.formInline.circleLat, 0])
        geoJson.properties.radius_ = this.formInline.circleRadius.toString()
      } else if (this.markerType === 'LINE') { // 线
        geoJson.geometry.coordinates = []
        this.formInline.gisPoints.forEach(item => {
          geoJson.geometry.coordinates.push([parseFloat(item[0]), parseFloat(item[1]), 0])
        })
      } else if (this.markerType === 'PLANE') { // 面
        const points = []
        this.formInline.gisPoints.forEach(item => {
          points.push([parseFloat(item[0]), parseFloat(item[1]), 0])
        })
        const lastIndex = points.length - 1
        if (points[0][0] !== points[lastIndex][0] ||
          points[0][1] !== points[lastIndex][1] ||
          points[0][2] !== points[lastIndex][2]) {
          points.push([
            points[0][0],
            points[0][1],
            points[0][2]
          ])
        }
        geoJson.geometry.coordinates = [points]
      }
      // 摄像机信息
      if (validateCameraInfo(this.formInline.cameraInfo)) {
        geoJson.properties.camera_info = JSON.stringify(this.formInline.cameraInfo)
      } else {
        geoJson.properties.camera_info = {}
      }
      if (this.formInline.deviceId) {
        geoJson.properties.deviceId = this.formInline.deviceId
      }

      updateMarker({
        id: this.serverMarkerId,
        name: this.formInline.markerName,
        geoJson: geoJson,
        deviceId: this.formInline.deviceId,
        values: this.getNewCustomInfo(),
        achievements: this.achievements,
        docs: this.docs
      }).then(res => {
        if (res.code === 200) {
          this.$Message('success', res.msg || '操作成功')
          this.$emit('refresh')
          this.$emit('createdMarkerMsg')
          this.close()
        }
      }).finally(() => {
        this.loading = false
      })
    },
    onModifyMark () {
      this.$refs.form.validate(val => {
        if (val) {
          this.modifyMark()
        } else {
          if (this.activeTab !== 1) {
            this.$message.error('基础信息数据校验失败')
          }
        }
      })
    },
    // 获取图层样式
    getLayerStyle (layerId) {
      for (let i = 0; i < this.layerList.length; i++) {
        if (this.layerList[i].id === layerId) {
          let style
          if (this.layerList[i].type === 'POINT') {
            style = markerStyles.adapterPointStyle(this.layerList[i].pointStyle)
          } else if (this.layerList[i].type === 'LINE') {
            style = markerStyles.adapterLineStyle(this.layerList[i].lineStyle)
          } else if (this.layerList[i].type === 'PLANE') {
            style = markerStyles.adapterPolygonStyle(this.layerList[i].planeStyle)
          }
          return style
        }
      }
    },
    // 点标注经纬度改变
    onChangePos () {
      if (this.markerType === 'POINT') {
        let error = false
        this.$refs.form.validateField(['pointLon', 'pointLat', 'pointHeight'], (errorMsg, res) => {
          error = error || !!errorMsg
        })
        if (!error) {
          const gisPos = [this.formInline.pointLon, this.formInline.pointLat, this.formInline.pointHeight]
          if (this.markerEditor) {
            this.markerEditor.setGisPosition(gisPos)
            const cart = Cesium.Cartesian3.fromDegrees(this.formInline.pointLon, this.formInline.pointLat, this.formInline.pointHeight)
            this.$cesiumPlus.cameraManager.zoomToPosition(cart)
          }
        }
      }
    },
    // 圆修改
    onChangeCircle () {
      if (this.drawMode === CesiumPlus.DrawMode.Circle) {
        let error = false
        this.$refs.form.validateField(['circleLon', 'circleLat', 'circleRadius'], (errorMsg, res) => {
          error = error || !!errorMsg
        })
        if (!error && this.markerEditor) {
          const gisPos = {
            centerPosition: [parseFloat(this.formInline.circleLon), parseFloat(this.formInline.circleLat), 0],
            radius: parseFloat(this.formInline.circleRadius)
          }
          this.markerEditor.setGisPosition(gisPos)
          this.markerEditor.flyto()
        }
      }
    },
    // 线面修改
    onChangePoint () {
      for (let i = 0; i < this.formInline.gisPoints.length; i++) {
        const item = this.formInline.gisPoints[i]
        if (isNaN(Number(item[0])) || parseFloat(item[0]) < -180 || parseFloat(item[0]) > 180) {
          return
        }
        if (isNaN(Number(item[1])) || parseFloat(item[1]) < -90 || parseFloat(item[1]) > 90) {
          return
        }
      }
      const _position = []
      this.formInline.gisPoints.forEach(item => {
        _position.push([parseFloat(item[0]), parseFloat(item[1]), 0])
      })
      this.markerEditor.setGisPosition(_position)
      this.markerEditor.flyto()
    },
    // 同步编辑标注gis坐标
    syncMarkerPosition () {
      const marker = this.$cesiumPlus.markerManager.getMarkerById(this.serverMarkerId ? this.serverMarkerId : this.entityId)
      // 更新编辑后的坐标信息
      if (marker && this.markerEditor) {
        if (this.markerType === 'POINT') { // 点标注设置经纬度
          marker.setPosition(this.markerEditor.getGisPosition())
        } else if (this.drawMode === CesiumPlus.DrawMode.Circle) { // 圆标注
          const _position = this.markerEditor.getGisPosition()
          marker.setCircleGis(_position.centerPosition, _position.radius)
        } else if (this.markerType === 'LINE') { // 线
          marker.setPolylineGisPositions(this.markerEditor.getGisPosition())
          marker.setWallPositions(this.markerEditor.getGisPosition())
        } else if (this.markerType === 'PLANE') { // 面
          marker.setPolygonGisPositions(this.markerEditor.getGisPosition())
        }
      }
    },
    // 创建标注
    createMark () {
      this.loading = true
      const marker = this.$cesiumPlus.markerManager.getMarkerById(this.entityId)
      // 更新编辑后的坐标信息
      this.syncMarkerPosition()

      const geoJson = JSON.parse(marker.toGeoJson())
      geoJson.properties.name = this.formInline.markerName
      if (validateCameraInfo(this.formInline.cameraInfo)) {
        geoJson.properties.camera_info = JSON.stringify(this.formInline.cameraInfo)
      } else {
        geoJson.properties.camera_info = {}
      }
      // geoJson.properties.custom = this.getCustomInfo()
      // GeoJSON.addExtra(geoJson.properties, this.formInline.properties)
      geoJson.properties.center_pos_info = this.markerEditor.getCenterPosition()
      for (let i = 0; i < this.formInline.properties.length; i++) {
        const id = this.formInline.properties[i].id
        const value = this.formInline.properties[i].value
        geoJson.properties[id] = value
      }
      if (this.bindId) {
        addMarkerBatch({
          layerId: this.formInline.selectedLayer,
          tableId: this.formInline.tableId,
          marks: [{
            geoJson: geoJson,
            uniqueId: this.bindId,
            name: this.formInline.markerName
          }],
          achievements: this.achievements,
          docs: this.docs
        }).then(res => {
          if (res.code === 200) {
            this.$Message('success', res.msg || '操作成功')
            this.$cesiumPlus.markerManager.removeMarkerById(this.entityId)
            // if (res.data && this.$cesiumPlus.markerManager.getDataSourceByLayer(this.formInline.selectedLayer)) {
            //   this.$cesiumPlus.markerManager.removeMarkerById(this.entityId)
            //   const jsonData = JSON.parse(JSON.stringify(geoJson))
            //   jsonData.id = res.data[0]
            //   jsonData.layerId = this.formInline.selectedLayer
            //   const style = this.getLayerStyle(jsonData.layerId)
            //   this.$cesiumPlus.markerManager.addMarkerFromGeoJson(jsonData, [style])
            // }
            this.$emit('refresh')
            this.$store.dispatch('getMarkerList')
            this.close()
            this.$emit('createdMarkerMsg')
          }
        }).finally(() => {
          this.loading = false
        })
      } else {
        addMarker({
          layerId: this.formInline.selectedLayer,
          geoJson: geoJson,
          name: this.formInline.markerName,
          mark: {
            'values': this.getCustomInfo()
          },
          achievements: this.achievements,
          docs: this.docs
        }).then(res => {
          if (res.code === 200) {
            this.$Message('success', res.msg || '操作成功')
            if (res.data) {
              this.$cesiumPlus.markerManager.removeMarkerById(this.entityId)
              // const jsonData = JSON.parse(JSON.stringify(geoJson))
              // jsonData.id = res.data
              // jsonData.layerId = this.formInline.selectedLayer
              // const style = this.getLayerStyle(jsonData.layerId)
              // this.$cesiumPlus.markerManager.addMarkerFromGeoJson(jsonData, [style])
            }
            this.$emit('refresh')
            this.$store.dispatch('getMarkerList')
            this.close()
            this.$emit('createdMarkerMsg')
          }
        }).finally(() => {
          this.loading = false
        })
      }
    },
    onCreateMark () {
      this.$refs.form.validate((val, error) => {
        if (val) {
          this.createMark()
        } else {
          if (this.activeTab !== 1) {
            this.$message.error('基础信息数据校验失败')
          }
        }
      })
    },
    // 编辑模式
    onEditModel () {
      // this.detailModel = false
      // this.$nextTick(() => {
      //   this.$store.dispatch('setDrawState', true)
      // })
      // this.$emit('editMarker', this.serverMarkerId)
      // this.close()
      this.$store.commit('SET_EDIT_MARKER_DATA', {
        id: this.serverMarkerId,
        activeTab: this.activeTab
      })
    },
    // 删除标注
    async removeMarker () {
      await this.$Delete()
      const res = await delMarker({ ids: [this.serverMarkerId] })
      this.$Message('success', res.msg)
      this.$cesiumPlus.markerManager.removeMarkerById(this.serverMarkerId)
      this.$store.dispatch('removeMarker', this.serverMarkerId)
      this.close()
    },
    onClickItem (headerItem) {
      if (!headerItem.value || headerItem.value === '无') {
        return
      }
      if (headerItem.type === 'LIVE') {
        if (headerItem.value.indexOf('m3u8') >= 0 || headerItem.value.indexOf('flv') >= 0) {
          this.$emit('livePreviewMsg', { url: headerItem.value })
        } else {
          this.$Message('warning', '当前只支持m3u8， flv格式直播')
        }
      } else if (headerItem.type === 'LINK') {
        window.open(headerItem.value, '_target')
      }
    },
    clear () {
      const marker = this.$cesiumPlus.markerManager.getMarkerById(this.serverMarkerId || this.entityId)
      if (marker) {
        marker.show(true)
      }
      this.formInline = this.$options.data().formInline
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
      // 图层列表
      this.layerList = []
      this.entityId = undefined
      // 标注服务端id
      this.serverMarkerId = undefined
      // 标注类型
      this.markerType = undefined
      // 绑定标注id
      this.bindId = undefined
      // 是否可绑定表单
      this.isCanBindTable = false
      this.detailModel = false
      this.activeTab = 1
      // 多媒体数据
      this.achievements = []
      this.upFileList = []
      for (let i = 0; i < this.cancelTokens.length; i++) {
        this.cancelTokens[i].cancel('取消上传')
      }
      this.cancelTokens = []
      // 文档附件
      this.docs = []
      this.docsUpList = []
      for (let i = 0; i < this.docsCancelTokens.length; i++) {
        this.docsCancelTokens[i].cancel('取消上传')
      }
      this.docsCancelTokens = []

      if (this.markerEditor) {
        this.markerEditor.destroy()
        this.markerEditor = null
      }
    },
    close () {
      this.visible = false
      this.clear()
      this.$store.dispatch('selectMarker', undefined)
      this.$store.dispatch('setDrawState', false)
      this.$emit('closeMarkerAttribute', undefined)
      this.$store.commit('SET_POI2MARKER', {})
      this.$store.commit('SET_EDIT_MARKER_DATA', undefined)
      // if (!this.detailModel) {
      //   this.$emit('', undefined)
      // }
      setTimeout(() => {
        if (this.spaceSearchJeojson) {
          this.$store.dispatch('showLeft', false)
          this.$store.dispatch('showRight', true)
        }
      })
    },
    // 关闭
    onClose () {
      if (!this.serverMarkerId) {
        this.cancelMarker()
      } else {
        this.cancelModify()
      }
    },
    // 上传
    beforeUpload (file) {
      const isPic = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'video/mp4'
      const isLtSize = file.size / 1024 / 1024 < 100
      if (!isPic) {
        this.$Message('warning', '只能上传图片与视频!')
      } else if (!isLtSize) {
        this.$Message('warning', '上传数据大小不能超过 100 MB!')
      }
      return isPic && isLtSize
    },
    async onUploadData (file) {
      if (file.file.type.startsWith('video')) {
        this.upFileList.push({
          'uploadPrecentange': 0,
          'name': file.file.name,
          // 'url': res.url,
          'type': 'video',
          'isUpLoading': true
        })
      } else {
        this.upFileList.push({
          'uploadPrecentange': 0,
          'name': file.file.name,
          // 'url': res.url,
          'type': 'image',
          'isUpLoading': true
        })
      }
      // this.uploadPrecentange = 0
      const res = await uploadOss(file.file, (loaded, total) => {
        const uploadPrecentange = parseInt(loaded / total * 100)
        this.upFileList.forEach(item => {
          if (item.name === file.file.name) {
            item.uploadPrecentange = uploadPrecentange
            item.isUpLoading = true
          }
        })
        // this.isUpLoading = true
        // this.uploadPrecentange = parseInt(loaded / total * 100)
      }, (cancelToken) => {
        this.cancelTokens.push(cancelToken)
      })
      if (res.url) {
        // this.upFileList.forEach(item => {
        //   if (item.name === res.fileName) {
        //     item.uploadPrecentange = 0
        //     item.isUpLoading = false
        //   }
        // })
        const index = this.upFileList.findIndex((item) => {
          return item.name === res.fileName
        })
        if (index >= 0) {
          this.upFileList.splice(index, 1)
          if (res.fileSuffix.toLowerCase().includes('mp4')) {
            this.achievements.splice(0, 0, {
              type: 'video',
              url: res.url
            })
          } else if (res.fileSuffix.toLowerCase().includes('png') || res.fileSuffix.toLowerCase().includes('jpg') || res.fileSuffix.toLowerCase().includes('jpeg')) {
            this.achievements.splice(0, 0, {
              type: 'image',
              url: res.url
            })
          }
        }
      }
    },
    handleSuccess (response, file, fileList) {
      if (this.upFileList.length < fileList.length) {

      }
    },
    // 图片预览
    onPreviewPic (item, index) {
      const list = JSON.parse(JSON.stringify(this.achievements))
      list.forEach(item => {
        item.format = item.type
      })
      this.$emit('previewPicMsg', {
        list: list,
        index: index
      })
    },
    // 图片删除
    onDeletePic (item, index) {
      this.achievements.splice(index, 1)
    },
    // 文档数据上传
    beforeDocsUpload (file) {
      const isPic = file.type === 'application/pdf'
      const isLtSize = file.size / 1024 / 1024 < 10
      if (!isPic) {
        this.$Message('warning', '只能上传pdf!')
      } else if (!isLtSize) {
        this.$Message('warning', '上传数据大小不能超过 10 MB!')
      }
      return isPic && isLtSize
    },
    async onUploadDocs (file) {
      this.docsUpList.push({
        'uploadPrecentange': 0,
        'name': file.file.name,
        'type': 'pdf',
        'isUpLoading': true
      })
      const res = await uploadOss(file.file, (loaded, total) => {
        const uploadPrecentange = parseInt(loaded / total * 100)
        this.docsUpList.forEach(item => {
          if (item.name === file.file.name) {
            item.uploadPrecentange = uploadPrecentange
            item.isUpLoading = true
          }
        })
      }, (cancelToken) => {
        this.docsCancelTokens.push(cancelToken)
      })
      if (res.url) {
        const index = this.docsUpList.findIndex((item) => {
          return item.name === res.fileName
        })
        if (index >= 0) {
          this.docsUpList.splice(index, 1)
          this.docs.splice(0, 0, {
            type: 'pdf',
            url: res.url,
            name: res.fileName,
            status: 'success'
          })
        }
      }
    },
    onPreviewPdf (item) {
      window.open(item.url)
    },
    onRemovePdf (item, index) {
      this.docs.splice(index, 1)
    },
    onCancelUpPdf (item, index) {

    },
    // 更新标注位置
    updateMarkerPosition (position) {
      if (this.markerType === 'POINT') { // 点标注设置经纬度
        // const gisPos = this.$cesiumPlus.utils.cartesianToLonLat(position)
        this.formInline.pointLon = parseFloat(position[0].toFixed(6))
        this.formInline.pointLat = parseFloat(position[1].toFixed(6))
        this.formInline.pointHeight = parseFloat(position[2].toFixed(3))
      } else if (this.drawMode === CesiumPlus.DrawMode.Circle) { // 圆标注
        const circleCenter = position.centerPosition
        const radius = position.radius
        this.formInline.circleLon = parseFloat(circleCenter[0].toFixed(6))
        this.formInline.circleLat = parseFloat(circleCenter[1].toFixed(6))
        this.formInline.circleRadius = parseFloat(radius.toFixed(3))
      } else if (this.markerType === 'LINE') { // 线
        this.formInline.gisPoints = []
        const polylineGis = position
        polylineGis.forEach(item => {
          const pos = [
            parseFloat(item[0].toFixed(6)),
            parseFloat(item[1].toFixed(6))
          ]
          this.formInline.gisPoints.push(pos)
        })
      } else if (this.markerType === 'PLANE') { // 面
        this.formInline.gisPoints = []
        const polygoneGis = position
        polygoneGis.forEach(item => {
          const pos = [
            parseFloat(item[0].toFixed(6)),
            parseFloat(item[1].toFixed(6))
          ]
          this.formInline.gisPoints.push(pos)
        })
      }
    },
    onClearCameraViewer () {
      this.formInline.cameraInfo = {}
    },
    onGetCurCameraViewer () {
      const position = this.$cesiumPlus.cameraManager.getCameraPosition()
      const orientation = this.$cesiumPlus.cameraManager.getCameraDirection()
      this.formInline.cameraInfo = {
        cameraLon: position[0].toFixed(6),
        cameraLat: position[1].toFixed(6),
        cameraHeight: position[2].toFixed(2),
        cameraHeading: orientation[0].toFixed(6),
        cameraPitch: orientation[1].toFixed(6),
        cameraRoll: orientation[2].toFixed(6)
      }
    },
    onShowHTMLEditor () {
      const marker = this.$cesiumPlus.markerManager.getMarkerById(this.serverMarkerId)
      this.$emit('showHTMLEditorMsg', {
        markerId: this.serverMarkerId,
        markerName: marker.name,
        html: marker.getProperties('richSnippets') || ''
      })
    },
    // 通过deviceId获取融合通信标注
    getMarkerByDeviceId (layerId, deviceId) {
      let marker
      const markers = this.markerDatas.find(item => {
        return item.id === layerId
      })
      if (markers && markers.marks && markers.marks.length) {
        marker = markers.marks.find(item => {
          return item.deviceId === deviceId
        })
      }
      return marker
    },
    // 创建融合通信标注
    async onCreateSppucMarker () {
      await this.$refs.form.validate()
      // 是否有相同deviceId的标注
      if (!this.serverMarkerId && this.getMarkerByDeviceId(this.formInline.selectedLayer, this.formInline.deviceId)) {
        this.$Message('error', '图层中已经有相同设备ID的标注了')
        return
      }
      // 更新编辑后的坐标信息
      this.syncMarkerPosition()
      const pointData = {
        name: this.formInline.markerName,
        deviceId: this.formInline.deviceId,
        lon: this.formInline.pointLon,
        lat: this.formInline.pointLat,
        height_: `[${this.formInline.pointHeight}]`,
        draw_mode_: CesiumPlus.DrawMode.Marker
      }

      const geoJson = GeoJSON.parse(pointData, { Point: ['lat', 'lon'] })
      // geoJson.properties.name = this.formInline.markerName
      if (validateCameraInfo(this.formInline.cameraInfo)) {
        geoJson.properties.camera_info = JSON.stringify(this.formInline.cameraInfo)
      } else {
        geoJson.properties.camera_info = {}
      }
      // geoJson.properties.deviceId = this.formInline.deviceId
      const markerData = {
        geoJson: geoJson,
        deviceId: this.formInline.deviceId,
        name: this.formInline.markerName
      }
      const res = await addDeviceMarkerBatch({
        layerId: this.formInline.selectedLayer,
        marks: [markerData]
      })
      this.$Message('success', res.msg || '操作成功')
      if (this.entityId) {
        this.$cesiumPlus.markerManager.removeMarkerById(this.entityId)
      }
      this.$emit('refresh')
      this.$store.dispatch('getMarkerList')
      this.close()
      this.$emit('createdMarkerMsg')
    }
  }
}
</script>
<style lang="scss">
.marker-attribute{
  .el-form-item__content{
    margin-left: 100px;
  }
  .el-form-item__label{
    width: 104px;
    padding: 0 1px 0 0;
  }
  .el-form-item__label,
  .el-input__inner{
    font-size: 12px !important;
  }
  .el-progress-circle{
    width: 50px !important;
    height: 50px !important;
    svg{
      path:first-child {
        stroke: #666;
      }
    }
  }
  .el-progress__text{
    color: #fff;
  }
  .el-date-editor{
    .el-input__prefix{
      left:130px
    }
  }
  .formContainer{
    .el-form-item__error{
      margin-left: 10px;
    }
    .el-form-item__label{
      color: #999999;
    }
    .el-form-item{
      width: 270px;
    }
  }
  // .accessory-item{
  //   .el-progress-bar{
  //     margin-left: -30px;
  //     padding-right: 30px;
  //   }
  //   .el-progress__text{
  //     margin-top: -40px;
  //   }
  // }
  .point-item{
    .el-form-item{
      margin-bottom: 20px;
      .el-form-item__label{
        transform: translateX(4px);
      }
    }
  }
  .el-date-editor .el-input__suffix {
    right: 5px;
    height: 30px;
    background: #3e3f3f;
    transform: translateY(6px);
  }
  .el-select .el-input .el-input__inner{
    height: 32px !important;
  }
  .el-select .el-tag{
    max-width: 75px;
  }
}
</style>
<style lang="scss" scoped>
.marker-attribute {
  .tab-panel{
    width: 32px;
    .tab-header{
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 32px;
      height: 74px;
      background: rgba(12, 12, 13, 0.6);
      border-radius: 6px 0px 0px 6px;
      padding: 5px;
      font-size: 14px;
      line-height: 1.1;
      margin: 10px 0;
      cursor: pointer;
      &.active{
        background: #00A4F0;
      }
    }
  }
  .top-tab{
    width: 280px;
    height: 32px;
    display: flex;
    flex-direction: row;
    .tab-header{
      // display: flex;
      // flex-direction: row;
      // justify-content: center;
      // width: 32px;
      background: rgba(255, 255, 255, 0.05);
      border: 1px solid #464748;
      font-size: 14px;
      line-height: 32px;
      padding: 0 10px;
      cursor: pointer;
      min-width: 75px;
      &.active{
        background: #00A4F0;
        border-color: #00A4F0;
      }
      &:first-child {
        // border-radius: 6px 0 0 6px;
        border-top-left-radius: 6px;
        border-bottom-left-radius: 6px;
      }
      &:last-child {
        // border-radius: 0 6px 6px 0;
        border-top-right-radius: 6px;
        border-bottom-right-radius: 6px;
      }
    }
  }

  .el-dialog{
    // .el-form-item__label{
    //   width: 100px;
    // }
  }
  .header{
    border-bottom: 1px solid #FFFFFF !important;
  }
  .footer {
    width: 100%;
    height: 50px;
    background: rgba(255, 255, 255, 0.05) !important;
    border-radius: 0px 0px 4px 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    .left {
      width: 63px;
      display: flex;
      justify-content: space-between;
      img {
        cursor: pointer;
      }
    }
    .right {
      width: 100%;
      text-align: right;
      .el-button{
        width: 80px;
        height: 32px;
      }
    }
  }
  .space-line{
    width: 260px;
    height: 1px;
    margin: 0 auto;
    margin-bottom: 20px;
    background-color: rgba($color: #ffffff, $alpha: 0.1) ;
  }
  .content {
    margin: 10px 0px;
    font-size: 12px !important;
    overflow-y: overlay;
    overflow-x: hidden;
    max-height: 380px;
    min-height: 200px;
    // &:hover{
    //   overflow-y: overlay;
    // }
    .tip {
      svg {
        width: 12px;
        height: 12px;
        font-size: 12px;
      }
      color: #999999;
      text-align: left;
      height: 49px;
    }
    .formContainer{
      max-height: 380px;
      overflow-y: hidden;
      overflow-x: hidden;
      padding: 0 20px;
      // .over-line .ant-form-item .ant-form-item-label {
      //   line-height: 17px;
      // }
      &:hover{
        overflow-y: overlay;
      }
      .attribute-item {
        width: 160px;
      }
      .bind-btn{
        margin-bottom: 16px;
        margin-left: 106px;
        margin-right: 4px;
        // margin-top: -10px;
        width: 160px;
        font-size: 12px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #00A4F0 !important;
        border: 1px dashed #00A4F0 !important;
        border-radius: 6px;
        background: unset !important;
        &.is-disabled{
          border-color: rgba($color: #ffffff, $alpha: 0.3) !important;
          color: rgba($color: #ffffff, $alpha: 0.5) !important;
        }
      }
    }
    .attribute-item2{
      margin-bottom: 10px;
      .title{
        display: inline-block;
        width: 90px;
        text-align: right;
        color: $font-color9;
        vertical-align: top;
        word-break: break-all;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .title2{
        display: inline;
        text-align: right;
        color: $font-color9;
        vertical-align: top;
        word-break: break-all;
        white-space:pre-wrap;
      }
      .value{
        display: inline-block;
        width: 160px;
        text-align: left;
        color: $font-colorf;
        word-break: break-all;
        white-space:pre-wrap;
        &.link{
          cursor: pointer;
          color: $primary-color;
          text-decoration: underline
        }
      }
    }
    .point-item{
      width: 280px;
      border: 1px solid rgba($color: #ffffff, $alpha: 0.06);
      border-radius: 10px;
      margin-left: -5px;
      margin-bottom: 22px;
      padding-top: 10px;
      &:last-child{
        margin-bottom: 0px;
      }
      .name-tag{
        width: 80px;
        height: 20px;
        background: linear-gradient(-60deg, #0971D2, #00A4F0);
        box-shadow: 0px 1px 4px 0px #001F3C;
        border-radius: 10px 10px 10px 0px;
        margin-top: -20px;
      }
    }
    .image-content{
      display: flex;
      flex-wrap: wrap;
      // padding-top: 10px;
      padding-left: 20px;
      // min-height: 160px;
      .add-image {
        display: inline-block;
        width: 78px;
        height: 78px;
        background: rgba(255, 255, 255, 0.1);
        border: 1px dashed #7C7E81;
        border-radius: 6px;
        margin-right: 20px;
        line-height: 78px;
        font-size: 22px;
        margin-bottom: 20px;
        cursor: pointer;
        svg{
          width: 22px;
          height: 22px;
          font-size: 22px;
          opacity: 0.3;
        }
        &:hover{
          svg{
            color: $hover-color;
          }
        }
      }
      .upload-progress{
        width: 76px;
        height: 76px;
        margin-right: 20px;
        padding: 12px;
        border: 1px solid #7C7E81;
        background: #333333;
        border-radius: 6px;
        margin-bottom: 20px;
      }
      .picture{
        position: relative;
        display: inline-block;
        width: 76px;
        height: 76px;
        margin-right: 20px;
        margin-bottom: 20px;
        border-radius: 6px;
        // border: 0.01rem solid #7C7E81;
        cursor: pointer;
        .img-preview{
          width: 100%;
          height: 100%;
          border-radius: 6px;
          .image-slot{
            line-height: 76px;
          }
          .image-error{
            line-height: 73px;
            border: 1px solid $error-color;
            border-radius: 6px;
            span{
              color:$error-color;
              font-size: 14px
            }
          }
        }
        .cover{
          background: rgba($color: #000, $alpha: 0.6);
          width: 100%;
          height: 100%;
          left: 0px;
          top: -81px;
          position: relative;
          display: flex;
          justify-content: space-evenly;
          font-size: 16px;
          align-items: center;
          opacity: 0;
          border-radius: 6px;
          &:hover{
            opacity: 1
          }
        }
        .tag{
          position: absolute;
          right: 0px;
          bottom: 0px;
          width: 36px;
          height: 18px;
          background: rgba($color: #000, $alpha: 0.5);
          border-radius: 6px 0px 6px 0px;
          z-index: 10;
        }
      }
      .empty{
        width: 100%;
        padding-right: 20px;
      }
    }
    .upload-accessory{
      width: 270px;
      height: 160px;
      border: 1px dashed rgba($color: #00A4F0, $alpha: 0.6);
      background: rgba($color: #00A4F0, $alpha: 0.06);
      border-radius: 6px;
      font-size: 14px;
      color: #FFF;
      margin: 0 auto;
      padding: 50px 0;
      cursor: pointer;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .accessory-tips{
        color: #999999;
        font-size: 12px;
        margin-top: 4px;
      }
    }
    .upload-accessory2{
      width: 270px;
      height: 32px;
      border: 1px dashed rgba($color: #00A4F0, $alpha: 0.6);
      background: rgba($color: #00A4F0, $alpha: 0.06);
      border-radius: 6px;
      font-size: 14px;
      color: #00A4F0;
      margin: 0 auto;
      margin-bottom: 10px;
      cursor: pointer;
      img{
        transform: scale(0.5);
      }
    }
    .accessory-item{
      width: 270px;
      margin: 0 auto;
      // margin: 0 7px 0 29px;
      .name{
        svg{
          font-size: 16px;
          height: 32px;
          width: 16px;
          margin-right: 4px;
          // vertical-align: middle;
        }
        // width: 250px;
        height: 32px;
        line-height: 32px;
        text-align: left;
        padding-left: 4px;
        .name-text{
          display: inline-block;
          width: 210px;
          word-break: break-all;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .remove{
          display: none;
          &:hover{
            color: $hover-color;
          }
        }
        cursor: pointer;
      }
      .accessory-progress{
        width: 250px;
      }
      .progress-status{
        display: inline-block;
        height: 32px;
        width: 32px;
        line-height: 32px;
        vertical-align: top;
        text-align: right;
        .uploading,
        .success{
          color: #49C475;
          font-size: 14px;
        }
        .failed{
          color: $error-color;
          font-size: 14px;
        }
      }
      &:hover{
        .name {
          background: rgba($color: #FFFFFF, $alpha: 0.1);
          border-radius: 6px;
        }
        .remove{
          display: inline;
          margin-left: 16px;
        }
        .progress-status{
          display: none;
        }
      }
    }
  }
  .custom-item{
    margin-bottom: 15px;
    .el-form-item__content{
      >div{
        transform: translateX(3px);
      }
      .custom-label{
        display: inline-block;
        width: 100px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        color: #999999;
        position: absolute;
        left: -100px;
        padding-left: 8px;
        text-align: right;
        transform: translateX(6px);
      }
    }
  }
  .point-container{
    max-height: 380px;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 0 9px;
    margin: 0 10px;
  }
  .camera-btns{
    display: flex;
    margin: 20px auto;
    justify-content: space-around;
  }
}
</style>
